import { css } from 'styled-components';
import { colors } from '~/themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
const styles = css `
  min-height: 100vh;
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justfiy-content: space-between;

  ${mediaq.md `
    min-height: auto;
  `}
  ${mediaq.sm `
    min-height: auto;
  `}

  .layout-body {
    background-color: ${colors.snow};
    height: 100%;
    .contents {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 0;
      > div {
        width: 100%;
      }

      ${mediaq.md `
        padding: 0 0 18px 0;
      `}
    }
  }

  footer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    flex: 1;
    > div {
      width: 100%;
    }
  }
`;
export default styles;
